window.MC_SPECS = {
  "boutique-mattress-memory-foam": {
    "title": "Boutique Mattress",
    "feel": "Medium firm",
    "mechanism": "7 zone CrafterCoil pocket springs",
    "confirmed": true,
    "layers": [
      {
        "name": "Crafter Stretch Knit cover",
        "what": "a stretch knit cover quilted over the comfort layers",
        "does": "keeps the surface even and lets air move through",
        "feel": "The surface feels smooth and even and does not feel stuffy against your skin."
      },
      {
        "name": "Visco memory foam",
        "what": "a slow response memory foam quilted into the top",
        "does": "moulds to your shape and eases pressure at the shoulders and hips",
        "feel": "The surface slowly gives way and cradles your shoulders and hips rather than pushing back."
      },
      {
        "name": "CrafterCore Plus convoluted foam",
        "what": "an egg crate profile comfort foam under the memory foam",
        "does": "the peaks add cushioning and the channels let air move through the comfort layers",
        "feel": "A softer, airier layer under the memory foam, so the bed does not feel like it holds heat."
      },
      {
        "name": "Support foam",
        "what": "a support foam layer",
        "does": "keeps the comfort layers stable and level over the spring unit",
        "feel": "You do not feel this layer directly, but the softer layers above do not sink unevenly."
      },
      {
        "name": "7 zone CrafterCoil pocket springs",
        "what": "individually wrapped pocket springs arranged in seven zones, with two rows of heavier perimeter springs around all four sides",
        "does": "gives each part of your body its own support, isolates movement between sides of the bed and keeps the edges usable",
        "feel": "Your spine stays level through the night and a partner moving beside you barely registers."
      }
    ]
  },
  "boutique-deluxe-mattress": {
    "title": "Boutique Deluxe Mattress",
    "feel": "Medium firm",
    "mechanism": "CrafterCool-Ice gel memory foam over 7 zone CrafterCoil pocket springs",
    "confirmed": true,
    "layers": [
      {
        "name": "Crafter Stretch Knit cover",
        "what": "a stretch knit cover quilted over the comfort layers",
        "does": "keeps the surface even and lets air move through",
        "feel": "The surface feels smooth and even and does not feel stuffy against your skin."
      },
      {
        "name": "Visco memory foam",
        "what": "a slow response memory foam quilted into the top",
        "does": "moulds to your shape and eases pressure at the shoulders and hips",
        "feel": "The surface slowly gives way and cradles your shoulders and hips rather than pushing back."
      },
      {
        "name": "CrafterCore Plus convoluted foam",
        "what": "an egg crate profile comfort foam under the memory foam",
        "does": "the peaks add cushioning and the channels let air move through the comfort layers",
        "feel": "A softer, airier layer under the memory foam, so the bed does not feel like it holds heat."
      },
      {
        "name": "CrafterCool-Ice gel memory foam",
        "what": "a gel infused memory foam",
        "does": "draws heat away from your body while it contours to your shape",
        "feel": "The pressure relief of memory foam without the overnight warmth build up."
      },
      {
        "name": "Support foam",
        "what": "a support foam layer",
        "does": "keeps the comfort layers stable and level over the spring unit",
        "feel": "You do not feel this layer directly, but the softer layers above do not sink unevenly."
      },
      {
        "name": "7 zone CrafterCoil pocket springs",
        "what": "individually wrapped pocket springs arranged in seven zones, with two rows of heavier perimeter springs around all four sides",
        "does": "gives each part of your body its own support, isolates movement between sides of the bed and keeps the edges usable",
        "feel": "Your spine stays level through the night and a partner moving beside you barely registers."
      }
    ]
  },
  "luxury-mattress-australia-boutique": {
    "title": "Boutique Deluxe Plus Mattress",
    "feel": "Medium plush",
    "mechanism": "CrafterLastic latex over 7 zone CrafterCoil pocket springs",
    "confirmed": true,
    "layers": [
      {
        "name": "Crafter Stretch Knit cover",
        "what": "a stretch knit cover quilted over the comfort layers",
        "does": "keeps the surface even and lets air move through",
        "feel": "The surface feels smooth and even and does not feel stuffy against your skin."
      },
      {
        "name": "Visco memory foam",
        "what": "a slow response memory foam quilted into the top",
        "does": "moulds to your shape and eases pressure at the shoulders and hips",
        "feel": "The surface slowly gives way and cradles your shoulders and hips rather than pushing back."
      },
      {
        "name": "CrafterCore Plus convoluted foam",
        "what": "an egg crate profile comfort foam under the memory foam",
        "does": "the peaks add cushioning and the channels let air move through the comfort layers",
        "feel": "A softer, airier layer under the memory foam, so the bed does not feel like it holds heat."
      },
      {
        "name": "CrafterLastic latex",
        "what": "a latex comfort layer",
        "does": "gives a buoyant, responsive feel and springs back as you move",
        "feel": "Instead of slowly sinking, the surface gives and then springs back as you shift position."
      },
      {
        "name": "CrafterCool-Ice gel memory foam",
        "what": "a gel infused memory foam",
        "does": "draws heat away from your body while it contours to your shape",
        "feel": "The pressure relief of memory foam without the overnight warmth build up."
      },
      {
        "name": "Support foam",
        "what": "a support foam layer",
        "does": "keeps the comfort layers stable and level over the spring unit",
        "feel": "You do not feel this layer directly, but the softer layers above do not sink unevenly."
      },
      {
        "name": "7 zone CrafterCoil pocket springs",
        "what": "individually wrapped pocket springs arranged in seven zones, with two rows of heavier perimeter springs around all four sides",
        "does": "gives each part of your body its own support, isolates movement between sides of the bed and keeps the edges usable",
        "feel": "Your spine stays level through the night and a partner moving beside you barely registers."
      }
    ]
  },
  "boutique-extra-firm-mattress": {
    "title": "Boutique Extra Firm Mattress",
    "feel": "Extra firm",
    "mechanism": "Heavy duty 2.4mm 7 zone CrafterCoil pocket springs",
    "confirmed": true,
    "layers": [
      {
        "name": "Crafter Stretch Knit cover",
        "what": "a stretch knit cover quilted over the comfort layers",
        "does": "keeps the surface even and lets air move through",
        "feel": "The surface feels smooth and even and does not feel stuffy against your skin."
      },
      {
        "name": "Visco memory foam",
        "what": "a slow response memory foam quilted into the top",
        "does": "moulds to your shape and eases pressure at the shoulders and hips",
        "feel": "The surface slowly gives way and cradles your shoulders and hips rather than pushing back."
      },
      {
        "name": "CrafterCore Plus convoluted foam",
        "what": "an egg crate profile comfort foam under the memory foam",
        "does": "the peaks add cushioning and the channels let air move through the comfort layers",
        "feel": "A softer, airier layer under the memory foam, so the bed does not feel like it holds heat."
      },
      {
        "name": "CrafterHD extra firm foam",
        "what": "a support foam layer under the comfort layers",
        "does": "works with the 2.4mm springs to keep the surface firm and flat",
        "feel": "A firm, stable surface that holds you on top of the bed rather than in it."
      },
      {
        "name": "7 zone CrafterCoil pocket springs",
        "what": "individually wrapped 2.4mm pocket springs arranged in seven zones, with two rows of 2.4mm perimeter springs around all four sides",
        "does": "the heavier wire gives firm, even support right across the bed and a stable edge",
        "feel": "Firm support from edge to edge without the surface giving way under your hips."
      }
    ]
  },
  "boutique-craft-cell-mattress": {
    "title": "Boutique Craft Cell Mattress",
    "feel": "Medium firm",
    "mechanism": "CrafterCool-Ice gel memory foam over a 20cm support foam core with no springs",
    "confirmed": true,
    "layers": [
      {
        "name": "Crafter Stretch Knit cover",
        "what": "a stretch knit cover quilted over the comfort layers",
        "does": "keeps the surface even and lets air move through",
        "feel": "The surface feels smooth and even and does not feel stuffy against your skin."
      },
      {
        "name": "CrafterCool-Ice gel memory foam",
        "what": "a gel infused memory foam",
        "does": "draws heat away from your body while it contours to your shape",
        "feel": "The pressure relief of memory foam without the overnight warmth build up."
      },
      {
        "name": "Transition foam",
        "what": "a foam layer between the gel memory foam and the support below",
        "does": "spreads your weight so the comfort layers never bottom out",
        "feel": "A smooth step from the soft top to the firmer support underneath."
      },
      {
        "name": "20cm support foam core",
        "what": "a 20cm block of support foam",
        "does": "holds the whole mattress level with no springs at all",
        "feel": "Even, quiet support with no bounce, so a partner moving beside you barely registers."
      }
    ]
  },
  "hybrid-mattress-australia": {
    "title": "Boutique Craft Cell Hybrid Mattress",
    "feel": "Medium firm",
    "mechanism": "CrafterLastic latex over 5 zone CrafterCoil pocket springs in a foam edge box",
    "confirmed": true,
    "layers": [
      {
        "name": "Crafter Stretch Knit cover",
        "what": "a stretch knit cover quilted over the comfort layers",
        "does": "keeps the surface even and lets air move through",
        "feel": "The surface feels smooth and even and does not feel stuffy against your skin."
      },
      {
        "name": "CrafterLastic latex",
        "what": "a latex comfort layer",
        "does": "gives a buoyant, responsive feel and springs back as you move",
        "feel": "Instead of slowly sinking, the surface gives and then springs back as you shift position."
      },
      {
        "name": "CrafterCool-Ice gel memory foam",
        "what": "a gel infused memory foam",
        "does": "draws heat away from your body while it contours to your shape",
        "feel": "The pressure relief of memory foam without the overnight warmth build up."
      },
      {
        "name": "Transition foam",
        "what": "a foam layer between the gel memory foam and the support below",
        "does": "spreads your weight so the comfort layers never bottom out",
        "feel": "A smooth step from the soft top to the firmer support underneath."
      },
      {
        "name": "5 zone CrafterCoil pocket springs",
        "what": "individually wrapped pocket springs arranged in five zones",
        "does": "gives each part of your body its own support and isolates movement between sides of the bed",
        "feel": "Your spine stays level through the night and a partner moving beside you barely registers."
      },
      {
        "name": "CrafterEdge foam encasement",
        "what": "a foam box built around the spring unit",
        "does": "keeps the edges firm so the full width of the bed is usable",
        "feel": "You can sit or sleep right to the edge without it collapsing under you."
      }
    ]
  },
  "chiro-luxe": {
    "title": "Therapedic Chiro Luxe Mattress",
    "feel": "Medium",
    "mechanism": "TheraCoil honeycomb zoned micro barrel springs",
    "confirmed": false,
    "licensedNote": true,
    "layers": [
      {
        "name": "Quilted cover",
        "what": "a quilted cover, stitched rather than glued flat",
        "does": "keeps the top surface soft without losing the support underneath",
        "feel": "A soft, finished surface that does not feel stiff."
      },
      {
        "name": "Hygroflex orthopedic comfort layers",
        "what": "Hygroflex orthopedic comfort foam, tested for pressure redistribution",
        "does": "redistributes pressure across the body rather than concentrating it at the shoulders and hips",
        "feel": "Pressure points feel eased rather than dug into."
      },
      {
        "name": "TheraCoil honeycomb zoned micro barrel springs",
        "what": "a honeycomb zoned micro barrel spring system, a finer and more complex build than a standard pocket spring",
        "does": "supports your lumbar while letting your shoulders sink",
        "feel": "Your lower back feels held while your shoulders settle in."
      },
      {
        "name": "Pro-Box edge support",
        "what": "reinforced foam running around the mattress perimeter",
        "does": "holds your weight at the edge instead of collapsing",
        "feel": "You can sit or sleep at the very edge of the bed without it giving way."
      }
    ]
  },
  "exquisite-signature-mattress": {
    "title": "Therapedic Exquisite Signature Mattress",
    "feel": "Medium",
    "mechanism": "TheraCoil honeycomb zoned micro barrel springs",
    "confirmed": false,
    "licensedNote": true,
    "layers": [
      {
        "name": "Sense-Ice cooling fabric cover",
        "what": "a Sense-Ice cooling fabric cover, engineered to wick heat and moisture",
        "does": "wicks heat and moisture away from your body rather than just feeling cool on contact",
        "feel": "The surface stays cool to the touch through the night rather than warming up."
      },
      {
        "name": "Copper Gel layer",
        "what": "a copper infused gel comfort layer",
        "does": "adds a gel comfort layer infused with copper",
        "feel": "You do not feel this layer directly."
      },
      {
        "name": "Graphene Visco Elastic cooling foam",
        "what": "a graphene visco elastic memory foam",
        "does": "conducts heat away from your body instead of trapping it the way ordinary memory foam does",
        "feel": "The contouring feel of memory foam without the warmth that usually comes with it."
      },
      {
        "name": "Hygroflex orthopedic comfort layer",
        "what": "Hygroflex orthopedic comfort foam, tested for pressure redistribution",
        "does": "redistributes pressure across the body rather than concentrating it at the shoulders and hips",
        "feel": "Pressure points feel eased rather than dug into."
      },
      {
        "name": "TheraCoil honeycomb zoned micro barrel springs",
        "what": "a honeycomb zoned micro barrel spring system, a finer and more complex build than a standard pocket spring",
        "does": "supports your lumbar while letting your shoulders sink",
        "feel": "Your lower back feels held while your shoulders settle in."
      },
      {
        "name": "Pro-Box edge support",
        "what": "reinforced foam running around the mattress perimeter",
        "does": "holds your weight at the edge instead of collapsing",
        "feel": "You can sit or sleep at the very edge of the bed without it giving way."
      }
    ]
  },
  "exquisite-premier-mattress": {
    "title": "Therapedic Exquisite Premier Mattress",
    "feel": "Medium",
    "mechanism": "TheraCoil honeycomb zoned micro barrel springs",
    "confirmed": false,
    "licensedNote": true,
    "layers": [
      {
        "name": "Sense-Ice cooling fabric cover",
        "what": "a Sense-Ice cooling fabric cover, engineered to wick heat and moisture",
        "does": "wicks heat and moisture away rather than just feeling cool to the touch for the first few minutes",
        "feel": "The surface stays cool to the touch through the night rather than warming up."
      },
      {
        "name": "Viscool visco elastic foam",
        "what": "Viscool visco elastic memory foam",
        "does": "gives the pressure relief of memory foam without running as warm as standard foam",
        "feel": "Contouring pressure relief without the trapped heat."
      },
      {
        "name": "Latex comfort layer",
        "what": "a latex comfort layer",
        "does": "gives a durable, responsive top layer that keeps its feel over years of use",
        "feel": "A springy, responsive surface rather than the slow sink of synthetic foam."
      },
      {
        "name": "TheraCoil honeycomb zoned micro barrel springs",
        "what": "a honeycomb zoned micro barrel spring system, a finer and more complex build than a standard pocket spring",
        "does": "supports your lumbar while letting your shoulders sink",
        "feel": "Your lower back feels held while your shoulders settle in."
      },
      {
        "name": "Pro-Box edge support",
        "what": "reinforced foam running around the mattress perimeter",
        "does": "holds your weight at the edge instead of collapsing",
        "feel": "You can sit or sleep at the very edge of the bed without it giving way."
      }
    ]
  },
  "elevate-essential-mattress": {
    "title": "Therapedic Elevate Essential Mattress",
    "feel": "Medium",
    "mechanism": "TheraSeven zoned support system",
    "confirmed": false,
    "licensedNote": true,
    "layers": [
      {
        "name": "Quilted cover",
        "what": "a quilted cover, stitched to the same standard as the rest of the range",
        "does": "keeps the surface finished rather than left as a simple wrap",
        "feel": "A soft, finished top surface."
      },
      {
        "name": "High density comfort layers",
        "what": "a high density comfort foam",
        "does": "holds its shape for years rather than softening within months",
        "feel": "The surface support stays consistent instead of drooping over time."
      },
      {
        "name": "High density comfort layers",
        "what": "a second high density foam layer beneath the comfort layer above",
        "does": "adds a further stable base before the support springs",
        "feel": "Extra stability underfoot before you reach the spring layer."
      },
      {
        "name": "TheraSeven zoned support springs",
        "what": "a TheraSeven zoned support spring system, seven zones running under the spine",
        "does": "keeps your hips from sinking further than your shoulders do",
        "feel": "Your spine stays level regardless of sleeping position."
      }
    ]
  },
  "resort": {
    "title": "Resort Mattress",
    "feel": "Medium firm",
    "mechanism": "7 zone CrafterCoil pocket springs under a quilted top",
    "confirmed": true,
    "layers": [
      {
        "name": "Crafter Stretch Knit cover",
        "what": "a stretch knit cover quilted over the comfort layers",
        "does": "keeps the surface even and lets air move through",
        "feel": "The surface feels smooth and even and does not feel stuffy against your skin."
      },
      {
        "name": "Support foam",
        "what": "a 20mm support foam quilted into the top",
        "does": "gives a firm, even surface over the springs",
        "feel": "A firm, even surface without the sink of a thick foam top."
      },
      {
        "name": "7 zone CrafterCoil pocket springs",
        "what": "individually wrapped pocket springs arranged in seven zones, with a perimeter of heavier springs around all four sides",
        "does": "supports each part of your body separately and isolates movement between sides of the bed",
        "feel": "Your spine stays level and a partner moving beside you barely registers."
      }
    ]
  },
  "superior": {
    "title": "Superior Mattress",
    "feel": "Medium firm",
    "mechanism": "Memory foam over 7 zone CrafterCoil pocket springs",
    "confirmed": true,
    "layers": [
      {
        "name": "Quilted cover",
        "what": "a quilted cover over the comfort layers",
        "does": "keeps the surface even and lets air move through",
        "feel": "The surface feels smooth and even and does not feel stuffy against your skin."
      },
      {
        "name": "Memory foam",
        "what": "a memory foam quilted into the top",
        "does": "moulds to your shape and eases pressure at the shoulders and hips",
        "feel": "The surface gives slowly and cradles your shoulders and hips."
      },
      {
        "name": "Convoluted comfort foam",
        "what": "an egg crate profile comfort foam",
        "does": "adds cushioning and lets air move through the comfort layers",
        "feel": "A softer, airier layer under the memory foam."
      },
      {
        "name": "Support foam",
        "what": "a deep support foam layer",
        "does": "keeps the comfort layers stable over the spring unit",
        "feel": "You do not feel this layer directly, but the surface stays level."
      },
      {
        "name": "7 zone CrafterCoil pocket springs",
        "what": "individually wrapped pocket springs arranged in seven zones",
        "does": "supports each part of your body separately and isolates movement between sides of the bed",
        "feel": "Your spine stays level and a partner moving beside you barely registers."
      }
    ]
  },
  "retreat": {
    "title": "Retreat Mattress",
    "feel": "Firm",
    "mechanism": "Bonnell spring unit under a quilted support foam top",
    "confirmed": true,
    "layers": [
      {
        "name": "Crafter Stretch Knit cover",
        "what": "a stretch knit cover quilted over the comfort layers",
        "does": "keeps the surface even and lets air move through",
        "feel": "The surface feels smooth and even and does not feel stuffy against your skin."
      },
      {
        "name": "Support foam",
        "what": "a 20mm support foam quilted into the top",
        "does": "gives a firm, even surface over the springs",
        "feel": "A firm, even surface without the sink of a thick foam top."
      },
      {
        "name": "Bonnell spring unit",
        "what": "a Bonnell steel coil spring unit (not pocket springs)",
        "does": "gives consistent, firm support across the whole surface and keeps air moving through the mattress",
        "feel": "Firm, even support with airflow, distinct from the independent give of a pocket spring bed."
      }
    ]
  },
  "4-play-mattress": {
    "title": "4 Play Mattress",
    "feel": "Adjustable",
    "mechanism": "Zip top comfort panels over 7 zone pocket springs",
    "confirmed": false,
    "layers": [
      {
        "name": "Zip top comfort panels, one per side",
        "what": "a zip top comfort panel on each side of the mattress, sold as a set of four firmness combinations",
        "does": "lets each side of the bed be set to its own firmness by zipping in a different panel",
        "feel": "You and a partner can each choose a different firmness on your own side."
      },
      {
        "name": "7 zone pocket springs",
        "what": "individually wrapped pocket springs arranged in seven zones",
        "does": "keeps support consistent under each side while the panel on top changes the feel",
        "feel": "The base support stays steady no matter which firmness panel you choose on top."
      }
    ]
  },
  "grandeur": {
    "title": "Grandeur Mattress",
    "feel": "Medium firm",
    "mechanism": "CrafterLastic latex over 7 zone CrafterCoil pocket springs",
    "confirmed": true,
    "layers": [
      {
        "name": "Crafter Stretch Knit cover",
        "what": "a stretch knit cover with continuous quilting over the comfort layers",
        "does": "keeps the surface even and lets air move through",
        "feel": "The surface feels smooth and even and does not feel stuffy against your skin."
      },
      {
        "name": "CrafterLastic latex",
        "what": "a latex comfort layer",
        "does": "gives a buoyant, responsive feel and springs back as you move",
        "feel": "Instead of slowly sinking, the surface gives and then springs back as you shift position."
      },
      {
        "name": "CrafterCore Plus convoluted foam",
        "what": "two egg crate profile comfort foams, one under the latex and one below it",
        "does": "the peaks add cushioning and the channels let air move through the comfort layers",
        "feel": "A softer, airier layer under the latex, so the top has give without feeling dense."
      },
      {
        "name": "Support foam",
        "what": "a support foam layer",
        "does": "keeps the comfort layers stable and level over the spring unit",
        "feel": "You do not feel this layer directly, but the softer layers above do not sink unevenly."
      },
      {
        "name": "7 zone CrafterCoil pocket springs",
        "what": "individually wrapped pocket springs arranged in seven zones, with two rows of heavier perimeter springs around all four sides",
        "does": "gives each part of your body its own support, isolates movement between sides of the bed and keeps the edges usable",
        "feel": "Your spine stays level through the night and a partner moving beside you barely registers."
      }
    ]
  }
};
